export class RecodeEvents {
	// Events sent from server.
	public static readonly SERVER_SYSTEM_BALANCE_UPDATE: string = 'RecodeEvents::SERVER_SYSTEM_BALANCE_UPDATE';
	public static readonly SERVER_PLUGIN_SET_MUTE: string = 'RecodeEvents::SERVER_PLUGIN_SET_MUTE';
	public static readonly SERVER_GAMEPLAY_RESUME: string = 'RecodeEvents::SERVER_GAMEPLAY_RESUME';
	public static readonly SERVER_AUTOPLAY_INTERRUPT: string = 'RecodeEvents::SERVER_AUTOPLAY_INTERRUPT';
	public static readonly SERVER_PRELOADER_REMOVED: string = 'RecodeEvents::SERVER_PRELOADER_REMOVED';
	public static readonly SERVER_LAUNCH_LOBBY: string = 'RecodeEvents::SERVER_LAUNCH_LOBBY';
	public static readonly SERVER_LAUNCH_BANKING: string = 'RecodeEvents::SERVER_LAUNCH_BANKING';

	public static readonly SHOWING_ERROR: string = 'RecodeEvents::SHOWING_ERROR';
	public static readonly CLOSED_ERROR_DIALOG: string = 'RecodeEvents::CLOSED_ERROR_DIALOG';
	// Events sent from client.

	public static readonly VALIDATED_BET: string = 'RecodeEvents::VALIDATED_BET';
	public static readonly VALIDATED_BET_DIALOG_SHOWN: string = 'RecodeEvents::VALIDATED_BET_DIALOG_SHOWN';

	public static readonly VALIDATED_BET_COIN_SIZE_CHANGED: string = 'RecodeEvents::VALIDATED_BET_COIN_SIZE_CHANGED';
}



// WEBPACK FOOTER //
// ./@fantasmagames/slot/src/integration/RecodeEvents.ts